import React from "react";
import styled from "styled-components";
import SubTitle from "../../components/atoms/SubTitle";
import {device} from "../../assets/styles/media.js";
import Bullet from "../atoms/Bullet";

const SubText = styled.h5`
    margin-bottom: 20px;
    font-size: 20px;
    color: #30343a;

    ${device.tablet} {
        padding-top: 25px;
        font-size: 20px;
        margin-bottom: 0;
    }
    
    
    ${device.mobile} {
      font-size: 16px;
    }
`;

const TextBox = styled.div`
    margin-bottom: 45px;
    border: 1px solid #e8eaed;
    padding: 28px 30px;
    span {
        font-size: 18px;
        color: #ed8e0c;
        font-weight: 500;
    }
    ${device.tablet} {
        padding: 20px 25px;
        font-size: 17px;
        font-weight: 500;
        white-space: pre-wrap;
    }

    ${device.mobile}{
        padding: 20px;
        margin-bottom: 20px;
        span {
            font-size: 14px;
            font-weight: 500;
        }
    }
`;
const Text = styled.p`
    color: #444;
    font-size: 18px;
    line-height: 30px;
    white-space: pre-wrap;
    
    ${device.tablet} {
        padding: 20px 25px;
        font-size: 17px;
        font-weight: 500;
        white-space: pre-wrap;
    }
    ${device.mobile}{
        font-size: 14px;
        line-height: 20px;
    }
`;
const TableWrap = styled.table`
    width: 100%;
    text-align: center;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
`;
const Tr = styled.tr`
    td:not(:first-child) {
        border-left: 1px solid #bababa;
    }
`;
const Th = styled.th`
    background-color: #fbfbfb;
    padding: 16px;
    font-weight: 600;
    font-size: 18px;
    color: #222;
    border-top: 1px solid #bababa;

    &:not(:first-child) {
        border-left: 1px solid #bababa;
    }
    
    ${device.mobile}{
        font-size: 13px;
    }
    
`;
const Td = styled.td`
    padding: 18px;
    border-top: 1px solid #d6d6d6;
    border-bottom: 1px solid #d6d6d6;
    color: ${(props)=>props.highlight ? "#ed8e0c" : "#4a4a4a"};
    font-size: ${(props)=>props.highlight ? "16px" : "18px"};
    p {
        line-height: 30px;
        font-size: 18px;
        display: flex;
        justify-content: left;
        align-items: center;
        margin-left: 20px;
    }

    span {
        font-size: 14px;
        margin-left: 16px;
        text-align: left;
        display: block;
        font-weight: 500;
    }


    ${device.tablet} {
        padding: 13px;
        font-size: 17px;
        p {
            text-align: left;
            font-size: 17px;
        }

    }

    ${device.mobile} {
        padding: 15px 7px;
        font-size: 13px;
        letter-spacing: -0.5px;
        white-space: pre-wrap;
        line-height: 20px;
        font-weight: 400;

        p {
            line-height: 20px;
            font-size: 13px !important;
            text-align: left;
        }

        span {
            font-size: 13px;
        }


    }

`;


const Table = ({subTitle, subText, headers, data, highlightRows = [], text}) => {
    return (
        <>
            <SubTitle text={subTitle}/>
            {subText && <SubText>{subText}</SubText> }
            {text && <TextBox>
                <Text>{text}</Text>
            </TextBox>}

            <TableWrap>
                <colgroup>
                    {headers.map((header, index) => (
                        <col key={index} style={{width: header.width || "50%"}}/>
                    ))}

                </colgroup>
                <thead>
                <Tr>
                    {headers.map((header, index) => (
                        <Th key={index}>{header.name}</Th>
                    ))}
                </Tr>
                </thead>
                <tbody>
                {data.map((row, rowIndex) => (
                    <Tr key={rowIndex}>
                        {Array.isArray(row) ? row.map((cell, index) => (
                                <Td key={index}
                                    highlight={highlightRows.includes(rowIndex)}
                                >
                                    {cell}
                                </Td>
                            )) :
                            < >
                                <Td>{row.title}</Td>
                                <Td key={rowIndex}>{row.price}</Td>
                                <Td> {row.items.map((el, index) => (<>
                                        <Bullet key={index}>{el.desc1}</Bullet>
                                        {el.desc2 && <span>{el.desc2}</span>}
                                    </>
                                ))}
                                </Td>
                            </>
                        }
                    </Tr>
                ))}
                </tbody>
            </TableWrap>
        </>
    );
};

export default Table;
